import React, { Component } from "react";
import { connect } from "react-redux";
import actions from "../../actions/dienstregeling";
import Icon from "../Common/Icon";
import moment from "moment";

export class Disruptions extends Component {
  componentDidUpdate() {
    const {
      config,
      dienstregeling,
      alertsInfo,
      loading,
      loadingAlerts,
      alertsRouteId,
    } = this.props;
    if (
      loading ||
      loadingAlerts ||
      !config.disruptionsUrl ||
      alertsInfo !== undefined ||
      !alertsRouteId
    )
      return;
    this.props.requestDisruptions(
      config.disruptionsUrl,
      dienstregeling.route.agency_id,
      alertsRouteId
    );
  }
  render() {
    const { loading, alertsInfo = [], config = {} } = this.props;

    const {
      locale = "en",
      disruptionsTitleText = "Let op: op deze lijn is sprake van een omleiding/stremming",
      disruptionsShowText = "Bekijk details",
      disruptionsHideText = "Verberg details",
      disruptionsFromToText = "t/m",
      disruptionsCancelledStopText = "Vervallen halte",
      disruptionsReplacedStopText = "Vervangende halte",
      disruptionsNoCancelledStopsText = "Er zijn geen vervallen haltes.",
      disruptionsNoCancelledStopText = "N.v.t.",
      disruptionsNoReplacedStopText = "N.v.t.",
    } = config;

    moment.locale(locale);
    if (!alertsInfo || !alertsInfo.length) return null;

    return (
      <div
        className={`container container--center container--margin ${
          loading ? "container--loading" : ""
        }`}
      >
        <ul className="accordion-bordered__group js-collapse-group">
          <li className="accordion-bordered__item accordion-bordered__item--warning js-collapse is-collapsed">
            <button className="accordion-bordered__btn js-collapse-btn">
              <Icon
                iconName="storingen"
                className="accordion-bordered__icon--left"
              />
              <span className="accordion-bordered__title">
                {disruptionsTitleText}
              </span>
              <span className="accordion-bordered__indicator-remark accordion-bordered__indicator-remark--on-collapsed">
                {disruptionsShowText}
              </span>
              <span className="accordion-bordered__indicator-remark accordion-bordered__indicator-remark--on-expanded">
                {disruptionsHideText}
              </span>
              <Icon
                iconName="chevron-up"
                className="accordion-bordered__indicator"
              />
            </button>
            <div className="accordion-bordered__content js-collapse-content">
              {alertsInfo.map((info) => (
                <React.Fragment key={info.header}>
                  <h2>
                    {`
                      ${moment(
                        info.start_time,
                        "YYYY-MM-DDTHH:mm:ssZ",
                        true
                      ).format("D MMMM YYYY HH:mm")} 
                      ${disruptionsFromToText} 
                      ${moment(
                        info.end_time,
                        "YYYY-MM-DDTHH:mm:ssZ",
                        true
                      ).format("D MMMM YYYY HH:mm")}
                    `}
                  </h2>
                  <h3>{info.header}</h3>
                  <p>{info.description}</p>

                  {!info.stops.length ? (
                    disruptionsNoCancelledStopsText
                  ) : (
                    <React.Fragment>
                      <table className="halte__table mobile-hide">
                        <tbody>
                          <tr className="halte-table__row halte-table__row--heading">
                            <th className="halte-table__column halte-table__column--heading">
                              {disruptionsCancelledStopText}
                            </th>
                            <th className="halte-table__column halte-table__column--heading">
                              {disruptionsReplacedStopText}
                            </th>
                          </tr>
                          {info.stops.map((stop) => (
                            <tr
                              key={JSON.stringify(stop)}
                              className="halte-table__row"
                            >
                              <td>
                                {stop.Description ||
                                  disruptionsNoCancelledStopText}
                              </td>
                              <td
                                key={JSON.stringify(stop)}
                                className="halte-table__column"
                              >
                                {stop.ReplacedBy.Remark ||
                                  stop.ReplacedBy.Description ||
                                  disruptionsNoReplacedStopText}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <div className="halte__table mobile-only">
                        <ul className="halte-table__column">
                          <li className="halte-table__row halte-table__row--heading">
                            {disruptionsCancelledStopText}
                          </li>
                          {info.stops.map((stop) => (
                            <li
                              key={JSON.stringify(stop)}
                              className="halte-table__row"
                            >
                              {stop.Description ||
                                disruptionsNoCancelledStopText}
                            </li>
                          ))}
                        </ul>
                        <ul className="halte-table__column">
                          <li className="halte-table__row halte-table__row--heading">
                            {disruptionsReplacedStopText}
                          </li>
                          {info.stops.map((stop) => (
                            <li
                              key={JSON.stringify(stop)}
                              className="halte-table__row"
                            >
                              {stop.ReplacedBy.Remark ||
                                stop.ReplacedBy.Description ||
                                disruptionsNoReplacedStopText}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </React.Fragment>
                  )}
                </React.Fragment>
              ))}
            </div>
          </li>
        </ul>
      </div>
    );
  }
}

export default connect(
  (state) => {
    const {
      dienstregeling = {},
      alertsInfo,
      loadingAlerts = false,
      loading,
    } = state.dienstregeling;
    const { route = {} } = dienstregeling;
    const { alerts_active = [] } = route;

    return {
      dienstregeling,
      alerts_active,
      alertsInfo,
      loading,
      loadingAlerts,
      alertsRouteId: route.route_id,
    };
  },
  {
    requestDisruptions: actions.requestDisruptions,
  }
)(Disruptions);



// WEBPACK FOOTER //
// ./src/components/Dienstregeling/Disruptions.js